import React from 'react';

// Optional tag color for a deal. Shows on each of the deal's tasks, next to the property address.
export const DEAL_COLORS = [
  { name: 'Red', hex: '#D64545' },
  { name: 'Orange', hex: '#E8833A' },
  { name: 'Amber', hex: '#E0A526' },
  { name: 'Gold', hex: '#B8962E' },
  { name: 'Lime', hex: '#8BBF3C' },
  { name: 'Green', hex: '#2E9E5B' },
  { name: 'Teal', hex: '#1F9E9A' },
  { name: 'Cyan', hex: '#3BB4D8' },
  { name: 'Sky', hex: '#4A90D9' },
  { name: 'Blue', hex: '#2F5FB3' },
  { name: 'Indigo', hex: '#5353C6' },
  { name: 'Violet', hex: '#7E57C2' },
  { name: 'Purple', hex: '#9B4DB8' },
  { name: 'Magenta', hex: '#C2409B' },
  { name: 'Pink', hex: '#E07BA5' },
  { name: 'Brown', hex: '#8D6748' },
];

export function DealColorPicker({ value, onChange }) {
  return (
    <fieldset style={{ border: '1px solid #e7dfcc', borderRadius: 8, padding: 12, margin: '0 0 16px' }}>
      <legend style={{ fontWeight: 700, fontSize: 14, padding: '0 6px' }}>Deal color (optional)</legend>
      <p style={{ margin: '0 0 8px', fontSize: 13, color: '#5B6270' }}>
        The color shows on this deal's tasks so they're easy to tell apart. Pick one or leave it as No color.
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
        <button type="button" onClick={() => onChange('')} aria-pressed={!value}
          style={{ padding: '6px 10px', borderRadius: 6, border: `2px solid ${!value ? '#1A1A1A' : '#D5D9E0'}`, background: '#FFFFFF', color: '#1A1A1A', fontSize: 13, cursor: 'pointer' }}>
          No color
        </button>
        {DEAL_COLORS.map((c) => (
          <button key={c.hex} type="button" title={c.name} aria-label={c.name} aria-pressed={value === c.hex} onClick={() => onChange(c.hex)}
            style={{ width: 28, height: 28, borderRadius: '50%', background: c.hex, cursor: 'pointer', border: value === c.hex ? '3px solid #1A1A1A' : '2px solid #FFFFFF', boxShadow: '0 0 0 1px #D5D9E0' }} />
        ))}
      </div>
    </fieldset>
  );
}

// Small tag for a task: the deal's color bar and address.
export function DealTag({ color, address, onClick }) {
  if (!color && !address) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#5B6270', marginBottom: 2 }}>
      {color && <span style={{ width: 12, height: 12, borderRadius: 3, background: color, display: 'inline-block' }} />}
      {address && (onClick ? (
        <button type="button" onClick={onClick} title="Open transaction details" style={{ background: 'none', border: 'none', padding: 0, color: '#8C6D1F', fontWeight: 700, fontSize: 12, cursor: 'pointer', textDecoration: 'underline', textAlign: 'left' }}>{address}</button>
      ) : <span>{address}</span>)}
    </div>
  );
}
